import { useEffect, useState } from "react";
import { CalendarClock, AlertTriangle } from "lucide-react";
import { api } from "@/lib/leuteliaApi";

const fmt = (r) => (r.amount != null ? `${r.amount.toLocaleString("it-IT")} ${r.currency || ""}` : "importo da confermare");

export default function ProssimiPagamenti() {
  const [s, setS] = useState(null);
  useEffect(() => { api.adminDeadlines().then((d) => setS(d.summary)).catch(() => setS(null)); }, []);
  if (!s) return null;
  const totals = Object.entries(s.totals_30_days || {}).map(([k, v]) => `${v.toLocaleString("it-IT")} ${k}`).join(" + ") || "nessun importo";
  const urgent = s.urgent?.length > 0;
  return (
    <div className={`mt-5 rounded-xl border p-4 ${urgent ? "border-brand-maroon/40 bg-brand-maroon/5" : "border-brand-gold/40 bg-white"}`} data-testid="prossimi-pagamenti">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {urgent ? <AlertTriangle size={18} className="text-brand-maroon" /> : <CalendarClock size={18} className="text-brand-gold" />}
        <div className="font-serif text-[18px] text-brand-ink">Prossimi pagamenti · 30 giorni</div>
        <div className="text-[13px] text-brand-ink/70">Totale <b className="text-brand-ink" data-testid="prossimi-pagamenti-totale">{totals}</b> · {s.next_30_days.length} scadenz{s.next_30_days.length === 1 ? "a" : "e"}</div>
        {s.incomplete?.filter((r) => r.period !== "a consumo").length > 0 && <div className="text-[12px] text-brand-orange font-semibold" data-testid="prossimi-pagamenti-incompleti">{s.incomplete.filter((r) => r.period !== "a consumo").length} voci da completare nel registro</div>}
      </div>
      {s.next_30_days.length > 0 && (
        <ul className="mt-2 flex flex-wrap gap-2">
          {s.next_30_days.map((r) => (
            <li key={r.id} className={`rounded-lg px-3 py-1.5 text-[12px] ${r.days_left <= 7 ? "bg-brand-maroon text-white" : "bg-brand-cream/70 text-brand-ink"}`} data-testid={`prossimo-${r.id}`}>
              <b>{r.service}</b> · {new Date(r.due_date).toLocaleDateString("it-IT")} ({r.days_left === 0 ? "oggi" : `tra ${r.days_left} gg`}) · {fmt(r)} · {r.pay_method}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
